/** Literals, unlike a definition's id, so that records keyed by form id can be typed. */
export const NL_AOVQL_HEALTH_FORM_ID = 'nl-aovql-health'

export const NL_AOVQL_KNOWLEDGE_FORM_ID = 'nl-aovql-knowledge'
